import { steps } from '../constants';

export function validateStep(step: string): boolean {
  return (steps as string[]).includes(step);
}
